import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const AbvPriceActionPctForm = () => {

    const augFieldDefs = (fieldToFieldDef) => {
       fieldToFieldDef.prodId.expr = ExprUtils.whereParams('hierCode', 'PROD_HIER', 'isLeaf', true);
    }
  
  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}